<template>
    <div class="InvoiceManagement">
        <Search @search="search" :searchContent="searchContent"></Search>
        <el-table ref="multipleTable" v-loading="loading" :data="tableData" tooltip-effect="dark"
            element-loading-text="Loading" fit :default-sort="{ prop: 'date', order: 'descending' }">
            <!-- <el-table-column prop="orderNumber" label="订单编号" align="center" show-overflow-tooltip></el-table-column>
            <el-table-column prop="product" label="开票公司名称" align="center" show-overflow-tooltip></el-table-column>
            <el-table-column prop="number" label="产品名称" align="center" show-overflow-tooltip></el-table-column>
            <el-table-column prop="buyWay" label="状态" align="center" show-overflow-tooltip></el-table-column>
            <el-table-column prop="duration" label="订单实付金额" align="center" show-overflow-tooltip></el-table-column>
            <el-table-column prop="startTime" label="可开发票金额" align="center" show-overflow-tooltip></el-table-column>
            <el-table-column prop="startTime" label="发票内容" align="center" show-overflow-tooltip></el-table-column>
            <el-table-column prop="startTime" label="物流订单号" align="center" show-overflow-tooltip></el-table-column> -->
            <el-table-column label="序号" type="index" width="80" align="center">
            </el-table-column>
            <el-table-column prop="username_name" label="用户名" align="center" show-overflow-tooltip />
            <el-table-column prop="company_name" label="开票公司" align="center" show-overflow-tooltip />
            <el-table-column prop="amount_name" label="实付金额" align="center" show-overflow-tooltip>
                <template slot-scope="scope">
                    ￥{{ scope.row.amount_name }}
                </template>
            </el-table-column>
            <el-table-column label="发票类型" prop="type" algin="center">
                <template slot-scope="scope">
                    {{ getTextByType(scope.row.type, typeOptions) }}
                </template>
            </el-table-column>
            <el-table-column prop="banknum_name" label="开户行及账号" align="center" show-overflow-tooltip />
            <el-table-column label="开票状态" prop="status" algin="center" show-overflow-tooltip width="100">
              <template slot-scope="scope">
                <el-tag v-if="scope.row.status==0"> {{ getTextByType(scope.row.status, statusOptions) }}<span v-if="scope.row.oriId!=null">[重开]</span></el-tag>
                <el-tag type="success" v-if="scope.row.status==1"> {{ getTextByType(scope.row.status, statusOptions) }}<span v-if="scope.row.oriId!=null">[重开]</span></el-tag>
                <el-tag type="danger" v-if="scope.row.status==2"> {{ getTextByType(scope.row.status, statusOptions) }}</el-tag>
              </template>
            </el-table-column>
            <el-table-column label="审批状态" prop="status" algin="center" show-overflow-tooltip width="100">
              <template slot-scope="scope">
                <el-tag v-if="scope.row.approveStatus==0"> 审批中 </el-tag>
                <el-tag type="success" v-if="scope.row.approveStatus==1"> 通过</el-tag>
                <el-tag type="danger" v-if="scope.row.approveStatus==2"> 驳回</el-tag>
              </template>
            </el-table-column>
            <el-table-column label="操作" width="150">
                <template slot-scope="scope">
                    <el-button type="text" @click="goDetail(scope.row.id)">详情
                    </el-button>
                    <el-button type="text" v-show="scope.row.status == 1 ||  scope.row.status == 2" @click="download(scope.row)">下载发票
                    </el-button>
                    <el-button type="text" v-show="scope.row.status == 1" @click="reInvoice(scope.row)">申请重开
                    </el-button>
                </template>
            </el-table-column>
        </el-table>
        <div class="table-actions" style="text-align: center;">
            <!-- <el-button type="text" icon="el-icon-plus" v-show="licenseMakeStatus">创建许可证</el-button> -->
            您有订单还未开发票<el-button size="mini" type="primary" style="margin-left: 10px;" @click="addNewInvoice">去申请开票</el-button>
        </div>
        <pagination :total="total" :page.sync="listQuery.currentPage" :limit.sync="listQuery.pageSize"
            @pagination="getInit" />
        <InvoiceDetail ref="InvoiceDetail" v-if="detailVisible" @refresh="detailVisible = false"></InvoiceDetail>
        <el-dialog title="申请发票" :close-on-click-modal="false" class="Summit-dialog Summit-dialog_center" lock-scroll
            append-to-body width="86vw" custom-class="apply-invoice-dialog" :visible.sync="invocieVisible" :show-close="false">
            <div class="apply-invoice-layout">
                <div class="invoice-apply-search">
                    <el-form size="small" label-position="top" class="invoice-apply-search-form">
                        <el-row :gutter="12">
                            <el-col :span="6">
                                <el-form-item label="订单号">
                                    <el-input v-model.trim="unInvoiceQuery.orderNo" placeholder="请输入订单号" clearable />
                                </el-form-item>
                            </el-col>
                            <el-col :span="6">
                                <el-form-item label="订单名称">
                                    <el-input v-model.trim="unInvoiceQuery.orderName" placeholder="请输入订单名称" clearable />
                                </el-form-item>
                            </el-col>
                            <el-col :span="6">
                                <el-form-item label="付款开始时间">
                                    <el-date-picker
                                        v-model="unInvoiceQuery.payTimeSt"
                                        type="date"
                                        value-format="yyyy-MM-dd"
                                        placeholder="开始时间"
                                        style="width:100%"
                                    />
                                </el-form-item>
                            </el-col>
                            <el-col :span="6">
                                <el-form-item label="付款结束时间">
                                    <el-date-picker
                                        v-model="unInvoiceQuery.payTimeEnd"
                                        type="date"
                                        value-format="yyyy-MM-dd"
                                        placeholder="结束时间"
                                        style="width:100%"
                                    />
                                </el-form-item>
                            </el-col>
                        </el-row>
                        <div class="search-second-row">
                            <div class="query-tags">
                                <el-tag size="mini" type="success">已支付订单</el-tag>
                                <el-tag size="mini">线上购买</el-tag>
                            </div>
                            <div class="query-actions">
                                <el-button type="primary" @click="handleUnInvoiceSearch">搜索</el-button>
                                <el-button @click="unInvoiceQuery.orderNo='';unInvoiceQuery.orderName='';unInvoiceQuery.payTimeSt='';unInvoiceQuery.payTimeEnd='';handleUnInvoiceSearch();">重置</el-button>
                            </div>
                        </div>
                    </el-form>
                </div>

                <div class="apply-invoice-table-wrap">
                    <el-table :data="orderTableData" border v-loading="orderListLoading" height="100%">
                        <el-table-column prop="ordername" label="订单名" align="center"
                            show-overflow-tooltip></el-table-column>
                        <el-table-column prop="ordernum" label="订单号" align="center"
                            show-overflow-tooltip></el-table-column>
                        <el-table-column prop="tradeTime" label="交易时间" align="center" show-overflow-tooltip></el-table-column>
                        <el-table-column prop="paymentamount" label="实付金额" align="center" show-overflow-tooltip>
                            <template slot-scope="scope">
                                ￥{{ scope.row.paymentamount }}
                            </template>
                        </el-table-column>
                        <el-table-column label="操作" align="center" width="140">
                            <template slot-scope="scope">
                                <el-button type="text" @click="openApplyInvoiceDialog(scope.row)">开票申请</el-button>
                            </template>
                        </el-table-column>
                    </el-table>
                </div>

                <pagination
                    class="apply-invoice-pagination"
                    :total="orderTotal"
                    :page.sync="unInvoiceQuery.currentPage"
                    :limit.sync="unInvoiceQuery.pageSize"
                    @pagination="handleUnInvoicePagination"
                />
            </div>

            <span slot="footer" class="dialog-footer" style="display:block;text-align:right;">
                <el-button @click="cancel">取消</el-button>
            </span>
        </el-dialog>

        <el-dialog
            title="选择开票信息"
            :close-on-click-modal="false"
            class="Summit-dialog Summit-dialog_center"
            lock-scroll
            append-to-body
            width="1100px"
            custom-class="apply-profile-dialog"
            :visible.sync="applyProfileVisible"
        >
            <div class="invoice-profile-actions">
                <el-button type="primary" size="small" @click="openCreateProfile">新增开票信息</el-button>
            </div>

            <div v-loading="invoiceProfileLoading" class="invoice-profile-card-list">
                <div
                    v-for="item in invoiceProfileList"
                    :key="item.id"
                    class="invoice-profile-card"
                    :class="{ active: selectedInvoiceProfileId === item.id }"
                    @click="chooseInvoiceProfile(item)"
                >
                    <span class="profile-select-indicator" :class="{ checked: selectedInvoiceProfileId === item.id }">
                        <i v-if="selectedInvoiceProfileId === item.id" class="el-icon-check"></i>
                    </span>

                    <div class="card-top">
                        <div class="card-title-wrap">
                            <span class="card-title">{{ item.buyerName || '-' }}</span>
                            <el-tag size="mini" :type="item.invoiceType === '1' ? 'danger' : 'success'">
                                {{ invoiceTypeShortText(item.invoiceType) }}
                            </el-tag>
                            <el-tag v-if="item.isMain === 'Y'" size="mini" type="success">默认</el-tag>
                        </div>
                        <div class="card-actions">
                            <el-button type="text" @click.stop="openEditProfile(item)">编辑</el-button>
                            <el-button v-if="item.isMain !== 'Y'" type="text" @click.stop="setDefaultProfileInApply(item)">设为默认</el-button>
                            <el-button type="text" class="danger" @click.stop="removeProfileInApply(item)">删除</el-button>
                        </div>
                    </div>

                    <div class="card-body">
                        <div class="info-row">
                            <span class="label">发票类型</span>
                            <span class="value">{{ invoiceTypeText(item.invoiceType) }}</span>
                        </div>
                        <div class="info-row">
                            <span class="label">纳税人识别号</span>
                            <span class="value">{{ item.buyerTaxNo || '-' }}</span>
                        </div>
                        <div class="info-row">
                            <span class="label">开户信息</span>
                            <span class="value">{{ formatBankInfo(item) }}</span>
                        </div>
                        <div class="info-row">
                            <span class="label">联系方式</span>
                            <span class="value">{{ item.buyerPhone || '-' }}</span>
                        </div>
                        <div class="info-row">
                            <span class="label">邮箱</span>
                            <span class="value">{{ item.email || '-' }}</span>
                        </div>
                        <div class="info-row">
                            <span class="label">地址</span>
                            <span class="value">{{ item.buyerAddress || '-' }}</span>
                        </div>
                        <div class="info-row">
                            <span class="label">备注</span>
                            <span class="value">{{ item.remark || '-' }}</span>
                        </div>
                    </div>
                </div>
            </div>
            <el-empty v-if="!invoiceProfileLoading && !invoiceProfileList.length" description="暂无开票信息" />

            <span slot="footer" class="dialog-footer">
                <el-button @click="applyProfileVisible = false">取消</el-button>
                <el-button type="primary" :loading="invoiceApplying" @click="submitApplyInvoice">确定</el-button>
            </span>
        </el-dialog>

        <el-dialog
            :title="profileEditorMode === 'create' ? '新增开票信息' : '编辑开票信息'"
            :close-on-click-modal="false"
            class="Summit-dialog Summit-dialog_center"
            lock-scroll
            append-to-body
            width="760px"
            :visible.sync="profileEditorVisible"
        >
            <el-form ref="profileFormRef" :model="profileForm" :rules="profileRules" label-width="110px">
                <el-row :gutter="12">
                    <el-col :span="12">
                        <el-form-item label="开票名称" prop="buyerName">
                            <el-input v-model.trim="profileForm.buyerName" maxlength="255" />
                        </el-form-item>
                    </el-col>
                    <el-col :span="12">
                        <el-form-item label="发票类型" prop="invoiceType">
                            <el-select v-model="profileForm.invoiceType" style="width: 100%" clearable>
                                <el-option label="专票" value="1" />
                                <el-option label="普票" value="2" />
                            </el-select>
                        </el-form-item>
                    </el-col>
                    <el-col :span="12">
                        <el-form-item label="纳税人识别号" prop="buyerTaxNo">
                            <el-input v-model.trim="profileForm.buyerTaxNo" maxlength="255" />
                        </el-form-item>
                    </el-col>
                    <el-col :span="12">
                        <el-form-item label="联系方式">
                            <el-input v-model.trim="profileForm.buyerPhone" maxlength="255" />
                        </el-form-item>
                    </el-col>
                    <el-col :span="12">
                        <el-form-item label="开户行">
                            <el-input v-model.trim="profileForm.buyerBankName" maxlength="255" />
                        </el-form-item>
                    </el-col>
                    <el-col :span="12">
                        <el-form-item label="开户账号">
                            <el-input v-model.trim="profileForm.buyerBankAccount" maxlength="255" />
                        </el-form-item>
                    </el-col>
                    <el-col :span="12">
                        <el-form-item label="地址">
                            <el-input v-model.trim="profileForm.buyerAddress" maxlength="255" />
                        </el-form-item>
                    </el-col>
                    <el-col :span="12">
                        <el-form-item label="邮箱" prop="email">
                            <el-input v-model.trim="profileForm.email" maxlength="255" />
                        </el-form-item>
                    </el-col>
                    <el-col :span="24">
                        <el-form-item label="备注">
                            <el-input v-model.trim="profileForm.remark" type="textarea" :rows="2" maxlength="255" show-word-limit />
                        </el-form-item>
                    </el-col>
                    <el-col :span="24">
                        <el-form-item label="默认开票信息">
                            <el-switch v-model="profileMainSwitch" @change="syncProfileMainStatus" />
                        </el-form-item>
                    </el-col>
                </el-row>
            </el-form>
            <span slot="footer" class="dialog-footer">
                <el-button @click="profileEditorVisible = false">取消</el-button>
                <el-button type="primary" :loading="profileSubmitting" @click="submitProfileForm">确定</el-button>
            </span>
        </el-dialog>

      <el-dialog title="申请重开" :close-on-click-modal="false" class="Summit-dialog Summit-dialog_center" lock-scroll
                 append-to-body width="1100px" :visible.sync="reInvocieVisible" :show-close="false">

        <!-- 开票信息选择 -->
        <div class="invoice-profile-actions">
          <el-button type="primary" size="small" @click="openCreateProfile">新增开票信息</el-button>
        </div>
        <div v-loading="invoiceProfileLoading" class="invoice-profile-card-list">
          <div
            v-for="item in invoiceProfileList"
            :key="item.id"
            class="invoice-profile-card"
            :class="{ active: selectedInvoiceProfileId === item.id }"
            @click="chooseInvoiceProfile(item)"
          >
            <span class="profile-select-indicator" :class="{ checked: selectedInvoiceProfileId === item.id }">
              <i v-if="selectedInvoiceProfileId === item.id" class="el-icon-check"></i>
            </span>
            <div class="card-top">
              <div class="card-title-wrap">
                <span class="card-title">{{ item.buyerName || '-' }}</span>
                <el-tag size="mini" :type="item.invoiceType === '1' ? 'danger' : 'success'">{{ invoiceTypeShortText(item.invoiceType) }}</el-tag>
                <el-tag v-if="item.isMain === 'Y'" size="mini" type="success">默认</el-tag>
              </div>
              <div class="card-actions">
                <el-button type="text" @click.stop="openEditProfile(item)">编辑</el-button>
                <el-button v-if="item.isMain !== 'Y'" type="text" @click.stop="setDefaultProfileInApply(item)">设为默认</el-button>
                <el-button type="text" class="danger" @click.stop="removeProfileInApply(item)">删除</el-button>
              </div>
            </div>
            <div class="card-body">
              <div class="info-row"><span class="label">发票类型</span><span class="value">{{ invoiceTypeText(item.invoiceType) }}</span></div>
              <div class="info-row"><span class="label">纳税人识别号</span><span class="value">{{ item.buyerTaxNo || '-' }}</span></div>
              <div class="info-row"><span class="label">开户信息</span><span class="value">{{ formatBankInfo(item) }}</span></div>
              <div class="info-row"><span class="label">联系方式</span><span class="value">{{ item.buyerPhone || '-' }}</span></div>
              <div class="info-row"><span class="label">邮箱</span><span class="value">{{ item.email || '-' }}</span></div>
              <div class="info-row"><span class="label">地址</span><span class="value">{{ item.buyerAddress || '-' }}</span></div>
            </div>
          </div>
        </div>
        <el-empty v-if="!invoiceProfileLoading && !invoiceProfileList.length" description="暂无开票信息" />

        <!-- 申请原因 -->
        <el-form style="margin-top:16px;">
          <el-form-item label="申请原因">
            <el-input type="textarea" :rows="4" v-model="reRow.remark" placeholder="请输入申请重开的原因" />
          </el-form-item>
        </el-form>

        <span slot="footer" class="dialog-footer" style="display:block;text-align:right;">
          <el-button @click="cancelReInvoice">取消</el-button>
          <el-button type="primary" :loading="reInvoiceSubmitting" @click="submitReInvoice">确定</el-button>
        </span>
      </el-dialog>
    </div>
</template>

<script>
import Search from './Search.vue';
import InvoiceDetail from './InvoiceDetail.vue';
import Pagination from '@/components/Pagination/index.vue';
import request from '@/utils/request';
import {
    getInvoiceProfileList,
    modifyInvoiceProfile,
    removeInvoiceProfile,
    setDefaultInvoiceProfile
} from '@/assets/API/invoiceProfile';
import { mapState, mapMutations } from "vuex";
import define from "@/utils/define";
import { checkBlacklist } from '@/assets/API/login';

const defaultProfileForm = () => ({
    id: '',
    customerId: '',
    buyerName: '',
    buyerTaxNo: '',
    buyerPhone: '',
    buyerBankName: '',
    buyerBankAccount: '',
    buyerAddress: '',
    email: '',
    invoiceType: '',
    remark: '',
    isMain: 'N'
});

export default {
    components: {
        Search, InvoiceDetail, Pagination
    },
    data() {
        return {
            tableData: [],
            loading: false,
            detailVisible: false,
            listQuery: {
                superQueryJson: '',
                currentPage: 1,
                pageSize: 20,
                sort: "desc",
                sidx: "",
            },
            query: {
                userid: '',// 用户id
                dataType: 0,
            },
            total: 0,
            searchContent: "请输入软件产品标题或订单编号",
            statusOptions: [{ "fullName": "未开票", "id": "0" }, { "fullName": "已开票", "id": "1" },{ "fullName": "已作废", "id": "2" }],
            statusProps: { "label": "fullName", "value": "id" },
            typeOptions: [{ "fullName": "普通发票", "id": "0" }, { "fullName": "专用发票", "id": "1" }],
            typeProps: { "label": "fullName", "value": "id" },
            orderTableData: [],
            orderTotal: 0,
            invoiceMakeStatus: true,
            invocieVisible: false,
            choosedOrderList: [],
            orderListLoading: false,
            unInvoiceQuery: {
                currentPage: 1,
                pageSize: 10,
                orderNo: '',
                orderName: '',
                payTimeSt: '',
                payTimeEnd: '',
                paymentState: '1',
                purchaseMethod: 'online'
            },
            applyProfileVisible: false,
            invoiceProfileLoading: false,
            invoiceApplying: false,
            invoiceProfileList: [],
            selectedInvoiceProfileId: '',
            currentApplyOrder: null,
            profileEditorVisible: false,
            profileEditorMode: 'create',
            profileSubmitting: false,
            profileMainSwitch: false,
            profileForm: defaultProfileForm(),
            profileRules: {
                buyerName: [{ required: true, message: '请输入开票名称', trigger: 'blur' }],
                invoiceType: [{ required: true, message: '请选择发票类型', trigger: 'change' }],
                buyerTaxNo: [{ required: true, message: '请输入纳税人识别号', trigger: 'blur' }],
                email: [{ required: true, message: '请输入邮箱', trigger: 'blur' }]
            },
            reInvocieVisible:false,
            reInvoiceRemark:"",
            reInvoiceSubmitting: false,
            reRow:{}
        };
    },
    computed: {
        ...mapState("user", ["userInfo"]),
    },
    mounted() {
        this.query.userid = this.userInfo.id;
        this.getInit();
    },
    watch: {

    },
    methods: {
        getCustomerId() {
            const customerId = this.userInfo?.id || '';
            return String(customerId || '');
        },
        ensureCustomerId() {
            const customerId = this.getCustomerId();
            if (!customerId) {
                this.$message.warning('登录失效请刷新页面');
                return '';
            }
            return customerId;
        },
        getTextByType(data, list) {
            let result = "-";
            list.forEach(e => {
                if (e.id == data) {
                    result = e.fullName;
                }
            });
            return result;
        },
        invoiceTypeText(type) {
            if (String(type) === '1') return '增值税专用发票';
            if (String(type) === '2') return '增值税普通发票';
            return '-';
        },
        invoiceTypeShortText(type) {
            if (String(type) === '1') return '专票';
            if (String(type) === '2') return '普票';
            return '-';
        },
        formatBankInfo(item) {
            const bankName = item && item.buyerBankName ? item.buyerBankName : '-';
            const bankAccount = item && item.buyerBankAccount ? item.buyerBankAccount : '-';
            return `${bankName} / ${bankAccount}`;
        },
        async getOrderList() {
            const customerId = this.ensureCustomerId();
            if (!customerId) {
                this.orderTableData = [];
                this.orderTotal = 0;
                return;
            }
            this.orderListLoading = true;
            try {
                const params = {
                    ...this.unInvoiceQuery,
                    customerId,
                    paymentState: '1',
                    purchaseMethod: 'online'
                };
                const res = await request({
                    url: `/api/business/C_orderManage/getUnInvoceOrderList`,
                    method: 'post',
                    data: params
                });
                if (res.code == 200) {
                    const records = res?.data?.records || [];
                    this.orderTableData = records;
                    this.orderTotal = Number(res?.data?.total || 0);
                } else {
                    this.orderTableData = [];
                    this.orderTotal = 0;
                }
            } finally {
                this.orderListLoading = false;
            }
        },
        // 数据初始化
        getInit({ page, limit } = {}) {
            if (page) this.listQuery.currentPage = page;
            if (limit) this.listQuery.pageSize = limit;
            this.loading = true;
            if (this.query.userid) {
                let _query = {
                    ...this.listQuery,
                    ...this.query
                };
                request({
                    url: `/api/business/C_invoice/getList`,
                    method: 'post',
                    data: _query
                }).then(res => {
                    if (res.code == 200) {
                        this.loading = false;
                        this.tableData = res.data.list;
                        this.total = res.data.pagination.total;
                    }
                });
            }
        },
        goDetail(id) {
            this.detailVisible = true;
            this.$nextTick(() => {
                this.$refs.InvoiceDetail.init(id);
            });
        },
        download(data) {
          // 下载发票
          let baseData = JSON.parse(data.content);
          if (baseData.length > 0) {
            baseData.forEach((item, index) => {
              if (item.fileId) {
                // 添加延迟，确保每个下载有足够时间触发
                setTimeout(() => {
                  request({
                    url: `api/file/Download/annex/${item.fileId}`,
                    method: 'get',
                  }).then(res => {
                    let url = res.data.url;
                    let name = item.name;
                    if (!url) return;
                    const baseUrl = url.indexOf("http") > -1 ? "" : this.define.APIURl;
                    const a = document.createElement("a");
                    a.setAttribute("download", name || "file_" + item.fileId);
                    const realUrl = baseUrl + url;
                    a.setAttribute("href", realUrl);
                    document.body.appendChild(a); // 先添加到DOM
                    a.click();
                    document.body.removeChild(a); // 下载后移除
                  });
                }, index * 1000); // 间隔1秒
              }
            });
          }
        },
        search(val) {
            this.query.keyword = val;
            this.listQuery.currentPage = 1;
            this.getInit();
        },
        addNewInvoice() {
            this.invocieVisible = true;
            this.unInvoiceQuery.currentPage = 1;
            this.getOrderList();
        },
        handleSelectionChange(val) {
            this.choosedOrderList = val;
        },
        cancel() {
            this.invocieVisible = false;
        },
        handleUnInvoiceSearch() {
            this.unInvoiceQuery.currentPage = 1;
            this.getOrderList();
        },
        handleUnInvoicePagination({ page, limit } = {}) {
            if (page) this.unInvoiceQuery.currentPage = page;
            if (limit) this.unInvoiceQuery.pageSize = limit;
            this.getOrderList();
        },
        getSelectedProfile() {
            if (!this.selectedInvoiceProfileId) return null;
            return this.invoiceProfileList.find(item => item.id === this.selectedInvoiceProfileId) || null;
        },
        async reloadInvoiceProfileList(customerId) {
            const res = await getInvoiceProfileList({ customerId });
            if (res.code !== 200) {
                this.$message.error(res.msg || '获取开票信息失败');
                return false;
            }
            this.invoiceProfileList = Array.isArray(res.data) ? res.data : [];
            return true;
        },
        async openApplyInvoiceDialog(row) {
            const customerId = this.ensureCustomerId();
            if (!customerId) {
                return;
            }

            const amount = Number(row?.paymentamount || 0);
            if (amount <= 0) {
                this.$message.warning('该订单实付金额为 0，无需开票');
                return;
            }

            this.currentApplyOrder = row;
            this.invoiceProfileLoading = true;
            try {
                const ok = await this.reloadInvoiceProfileList(customerId);
                if (!ok) {
                    return;
                }

                if (!this.invoiceProfileList.length) {
                    this.$message.warning('请先新增开票信息');
                    this.openCreateProfile();
                    return;
                }

                const byOrder = row?.invoiceProfileId
                  ? this.invoiceProfileList.find(item => item.id === row.invoiceProfileId)
                  : null;
                const byDefault = this.invoiceProfileList.find(item => item.isMain === 'Y');
                const active = byOrder || byDefault || this.invoiceProfileList[0];
                this.selectedInvoiceProfileId = active ? active.id : '';
                this.applyProfileVisible = true;
            } finally {
                this.invoiceProfileLoading = false;
            }
        },
        chooseInvoiceProfile(item) {
            this.selectedInvoiceProfileId = item.id;
        },
        openCreateProfile() {
            const customerId = this.ensureCustomerId();
            if (!customerId) return;

            this.profileEditorMode = 'create';
            const loginName = this.userInfo && (this.userInfo.realName || this.userInfo.username);
            const loginPhone = this.userInfo && (this.userInfo.phonenum || this.userInfo.phone);
            const loginEmail = this.userInfo && this.userInfo.email;
            this.profileForm = {
                ...defaultProfileForm(),
                customerId,
                buyerName: loginName || '',
                buyerPhone: loginPhone || '',
                email: loginEmail || ''
            };
            this.profileMainSwitch = false;
            this.profileEditorVisible = true;
            this.$nextTick(() => {
                if (this.$refs.profileFormRef) {
                    this.$refs.profileFormRef.clearValidate();
                }
            });
        },
        openEditProfile(item) {
            const current = item || this.getSelectedProfile();
            if (!current) {
                this.$message.warning('请先选择要编辑的开票信息');
                return;
            }
            this.profileEditorMode = 'edit';
            this.profileForm = { ...defaultProfileForm(), ...current };
            this.profileMainSwitch = this.profileForm.isMain === 'Y';
            this.profileEditorVisible = true;
            this.$nextTick(() => {
                if (this.$refs.profileFormRef) {
                    this.$refs.profileFormRef.clearValidate();
                }
            });
        },
        syncProfileMainStatus(val) {
            this.profileForm.isMain = val ? 'Y' : 'N';
        },
        submitProfileForm() {
            const customerId = this.ensureCustomerId();
            if (!customerId || !this.$refs.profileFormRef) return;
            this.$refs.profileFormRef.validate(async valid => {
                if (!valid) return;
                this.profileSubmitting = true;
                const currentEditId = this.profileForm.id;
                try {
                    const payload = {
                        ...this.profileForm,
                        customerId,
                        isMain: this.profileMainSwitch ? 'Y' : 'N'
                    };
                    const res = await modifyInvoiceProfile(payload);
                    if (res.code !== 200) {
                        this.$message.error(res.msg || '保存开票信息失败');
                        return;
                    }
                    this.$message.success(this.profileEditorMode === 'create' ? '新增成功' : '编辑成功');
                    this.profileEditorVisible = false;

                    const ok = await this.reloadInvoiceProfileList(customerId);
                    if (!ok) return;

                    if (this.profileEditorMode === 'edit' && currentEditId) {
                        const edited = this.invoiceProfileList.find(item => item.id === currentEditId);
                        if (edited) {
                            this.selectedInvoiceProfileId = edited.id;
                            return;
                        }
                    }
                    const main = this.invoiceProfileList.find(item => item.isMain === 'Y');
                    const first = this.invoiceProfileList[0];
                    this.selectedInvoiceProfileId = (main || first || {}).id || '';
                } finally {
                    this.profileSubmitting = false;
                }
            });
        },
        async setDefaultProfileInApply(item) {
            const ok = await this.$confirm('确认将该条记录设为默认开票信息吗？', '提示', {
                type: 'warning'
            }).catch(() => false);
            if (!ok) return;

            const res = await setDefaultInvoiceProfile(item.id);
            if (res.code !== 200) {
                this.$message.error(res.msg || '设置默认失败');
                return;
            }
            this.$message.success('设置默认成功');
            const customerId = this.ensureCustomerId();
            if (!customerId) return;
            await this.reloadInvoiceProfileList(customerId);
            const main = this.invoiceProfileList.find(profile => profile.isMain === 'Y');
            if (main) {
                this.selectedInvoiceProfileId = main.id;
            }
        },
        async removeProfileInApply(item) {
            const ok = await this.$confirm('确认删除该开票信息吗？删除后不可恢复。', '提示', {
                type: 'warning'
            }).catch(() => false);
            if (!ok) return;

            const res = await removeInvoiceProfile(item.id);
            if (res.code !== 200) {
                this.$message.error(res.msg || '删除失败');
                return;
            }
            this.$message.success('删除成功');
            const customerId = this.ensureCustomerId();
            if (!customerId) return;
            await this.reloadInvoiceProfileList(customerId);
            if (!this.invoiceProfileList.length) {
                this.selectedInvoiceProfileId = '';
                return;
            }
            if (this.selectedInvoiceProfileId === item.id) {
                const main = this.invoiceProfileList.find(profile => profile.isMain === 'Y');
                const first = this.invoiceProfileList[0];
                this.selectedInvoiceProfileId = (main || first || {}).id || '';
            }
        },
        async submitApplyInvoice() {
            if (!this.currentApplyOrder?.id) {
                this.$message.warning('订单数据异常，请刷新后重试');
                return;
            }
            if (!this.selectedInvoiceProfileId) {
                this.$message.warning('请选择开票信息');
                return;
            }

            const profile = this.invoiceProfileList.find(item => item.id === this.selectedInvoiceProfileId);
            if (!profile) {
                this.$message.warning('开票信息不存在，请重新选择');
                return;
            }

            const blacklistResult = await checkBlacklist({
                customerId: this.getCustomerId(),
                companyName: profile.buyerName || this.userInfo.companyname
            });
            if (!blacklistResult || blacklistResult.code !== 200) {
                this.$message.error((blacklistResult && blacklistResult.msg) || '当前用户禁止申请开票');
                return;
            }

            this.invoiceApplying = true;
            try {
                const data = {
                    status: 0,
                    type: profile.invoiceType === '1' ? 1 : 0,
                    taxrate: '',
                    username: this.userInfo.username,
                    userid: this.getCustomerId(),
                    company: profile.buyerName || this.userInfo.companyname,
                    ratenumber: profile.buyerTaxNo || this.userInfo.companysocialcreditcode,
                    phone: profile.buyerPhone || this.userInfo.phonenum,
                    email: profile.email || this.userInfo.email,
                    address: profile.buyerAddress || '',
                    banknum: `${profile.buyerBankName || ''}/${profile.buyerBankAccount || ''}`,
                    orderid: this.currentApplyOrder.id,
                    ordername: this.currentApplyOrder.ordernum || this.currentApplyOrder.ordername,
                    amount: Number(this.currentApplyOrder.paymentamount || 0),
                    amountgross: Number(this.currentApplyOrder.paymentamount || 0),
                    creatoruserid: this.getCustomerId(),
                    invoiceProfileId: profile.id
                };

                const res = await request({
                    url: '/api/business/C_invoice',
                    method: 'post',
                    data
                });

                this.$message({
                    message: res.msg,
                    type: res.code === 200 ? 'success' : 'error',
                    duration: 1000,
                    onClose: () => {
                        if (res.code === 200) {
                            this.applyProfileVisible = false;
                            this.getInit();
                            this.getOrderList();
                        }
                    }
                });
            } finally {
                this.invoiceApplying = false;
            }
        },
        async onConfirm() {
            // 根据选中的订单 choosedOrderList 生成未开票记录
            console.log(this.choosedOrderList, this.userInfo, 'sss');

            let orderids = this.choosedOrderList.map(e => e.id);
            let ordernames = this.choosedOrderList.map(e => e.ordernum);
            let totalBaseAmount = this.choosedOrderList.reduce((accumulator, current) => {
                return accumulator + current.baseamount;
            }, 0);
            let totalPaymentAmount = this.choosedOrderList.reduce((accumulator, current) => {
                return accumulator + current.paymentamount;
            }, 0);

            if (totalPaymentAmount <= 0) {
                this.$message.warning('所选订单实付金额合计为 0，无法申请开票');
                return;
            }

            const blacklistResult = await checkBlacklist({
                customerId: this.getCustomerId(),
                companyName: this.userInfo.companyname
            });
            if (!blacklistResult || blacklistResult.code !== 200) {
                this.$message.error((blacklistResult && blacklistResult.msg) || '当前用户禁止申请开票');
                return;
            }

            let data = {
                status: 0,
                type: 0,
                taxrate: '',
                // 用户信息
                username: this.userInfo.username,
                userid: this.userInfo.id,
                company: this.userInfo.companyname,
                ratenumber: this.userInfo.companysocialcreditcode,
                phone: this.userInfo.phonenum,
                // 订单信息
                orderid: orderids.toString(),
                ordername: ordernames.toString(),
                amount: totalPaymentAmount,
                amountgross: totalBaseAmount,
                creatoruserid: this.userInfo.id
            };
            request({
                url: '/api/business/C_invoice',
                method: 'post',
                data
            }).then(res => {
                this.$message({
                    message: res.msg,
                    type: 'success',
                    duration: 1000,
                    onClose: () => {
                        this.invocieVisible = false;
                        this.getInit();
                        this.getOrderList();
                    }
                });
            });
        },
      cancelReInvoice() {
        this.reInvocieVisible = false;
        this.reInvoiceSubmitting = false;
        this.reRow = {};
      },
      async reInvoice(row) {
          const customerId = this.ensureCustomerId();
          if (!customerId) return;
          this.reRow = { ...row, remark: '' };
          this.invoiceProfileLoading = true;
          try {
              const ok = await this.reloadInvoiceProfileList(customerId);
              if (!ok) return;
              if (!this.invoiceProfileList.length) {
                  this.$message.warning('请先新增开票信息');
                  this.openCreateProfile();
                  return;
              }
              const byDefault = this.invoiceProfileList.find(item => item.isMain === 'Y');
              const active = byDefault || this.invoiceProfileList[0];
              this.selectedInvoiceProfileId = active ? active.id : '';
              this.reInvocieVisible = true;
          } finally {
              this.invoiceProfileLoading = false;
          }
      },
      async submitReInvoice() {
        if (!this.reRow || !this.reRow.id) {
          this.$message.error('数据错误');
          return;
        }
        if (!this.selectedInvoiceProfileId) {
          this.$message.warning('请选择开票信息');
          return;
        }
        const profile = this.invoiceProfileList.find(item => item.id === this.selectedInvoiceProfileId);
        if (!profile) {
          this.$message.warning('开票信息不存在，请重新选择');
          return;
        }
        const blacklistResult = await checkBlacklist({
          customerId: this.getCustomerId(),
          companyName: profile.buyerName || this.userInfo.companyname
        });
        if (!blacklistResult || blacklistResult.code !== 200) {
          this.$message.error((blacklistResult && blacklistResult.msg) || '当前用户禁止申请开票');
          return;
        }
        this.reInvoiceSubmitting = true;
        const rowData = {
          ...this.reRow,
          company: profile.buyerName || this.userInfo.companyname,
          ratenumber: profile.buyerTaxNo || this.userInfo.companysocialcreditcode,
          phone: profile.buyerPhone || this.userInfo.phonenum,
          email: profile.email || this.userInfo.email,
          address: profile.buyerAddress || '',
          banknum: `${profile.buyerBankName || ''}/${profile.buyerBankAccount || ''}`,
          invoiceProfileId: profile.id
        };
        request({
          url: '/api/business/C_invoice/reInvoice',
          method: 'post',
          data: rowData
        }).then(res => {
          this.cancelReInvoice();
          this.$message({
            message: res.msg,
            type: 'success',
            duration: 1000,
            onClose: () => {
              this.getInit();
              this.getOrderList();
            }
          });
        }).finally(() => {
          this.reInvoiceSubmitting = false;
        });
      }
    }
};
</script>

<style scoped lang="scss" scoped>
.InvoiceManagement {
    height: calc(100vh - 120px);

    margin-top: 35px;
    // padding-left: 35px;
    // padding-right: 32px;
    background-color: #fff;
    padding: 10px;

    // table
    ::v-deep .el-table {
        // height: calc(100% - 125px) !important;
        height: calc(100% - 200px);
    }

    :deep .el-tabs__header {
        padding-top: 15px;
        // margin: 0 0 35px
    }

    ::v-deep .el-tabs__content {
        height: calc(100% - 90px);
    }

    ::v-deep .el-tab-pane {
        height: calc(100% - 50px);
    }

    ::v-deep .el-tabs--border-card {
        border: none;
        box-shadow: none;
    }

    :deep .el-table__header .has-gutter tr th {
        background-color: rgba(213, 231, 250, 1);
        border-right: 1px solid #fff;
        color: rgba(56, 56, 56, 1);
    }

    :deep .el-table__body-wrapper {
        height: calc(100% - 100px);
        overflow-y: auto;
    }

    // :deep .el-table__header {
    //     border-radius: 20px 20px, 0px, 0px;
    //     background-color: rgba(245, 245, 245, 1);
    // }

    // :deep .el-table th.el-table__cell {
    //     background-color: rgba(245, 245, 245, 1);
    //     border-radius: 20px;
    //     border: none;
    // }

    // :deep .el-table__body tr:hover>td {
    //     background-color: rgba(245, 245, 245, 1) !important;
    // }

    // :deep .el-table tr {
    //     height: 46px;
    // }

    // :deep .el-table__body-wrapper {
    //     height: calc(100% - 47px);
    //     overflow-y: auto;
    // }

    // :deep .el-table__empty-block {
    //     min-height: 50px;
    // }

    // :deep .el-table th.el-table__cell>.cell {
    //     font-size: 14px;
    //     font-weight: 400;
    //     line-height: 22.4px;
    //     color: rgba(128, 128, 128, 0.7);
    // }

    // ::v-deep .el-pagination {
    //     padding-top: 20px;
    // }
}

.table-actions {
    padding-top: 10px;
}

.invoice-apply-search {
    padding: 0 0 10px;
    background: #f8fbff;
    border: 1px solid #e4edf8;
    border-radius: 10px;
    padding: 12px 14px 8px;

    ::v-deep .el-form-item {
        margin-bottom: 8px;
    }

    .search-second-row {
        margin-top: 4px;
        display: flex;
        align-items: center;
        justify-content: space-between;
        border-top: 1px dashed #dbe7f7;
        padding-top: 8px;

        .query-tags {
            display: flex;
            gap: 8px;
        }

        .query-actions {
            display: flex;
            gap: 8px;
        }
    }
}

.invoice-profile-card-list {
    max-height: 56vh;
    overflow-y: auto;
    display: grid;
    grid-template-columns: repeat(2, minmax(0, 1fr));
    gap: 14px;
    padding-right: 4px;
}

.invoice-profile-actions {
    margin-bottom: 12px;
    display: flex;
    justify-content: space-between;
}

.invoice-profile-card {
    position: relative;
    border: 1px solid #ebeef5;
    border-radius: 12px;
    padding: 12px 12px 12px 34px;
    cursor: pointer;
    background: linear-gradient(180deg, #ffffff 0%, #fbfdff 100%);
    transition: all 0.2s ease;

    &:hover {
        border-color: #b8d7f7;
        box-shadow: 0 8px 20px rgba(43, 133, 229, 0.12);
        transform: translateY(-2px);
    }

    &.active {
        border-color: #67c23a;
        box-shadow: 0 0 0 2px rgba(64, 158, 255, 0.12);
    }

    .profile-select-indicator {
        position: absolute;
        top: 10px;
        left: 10px;
        width: 14px;
        height: 14px;
        border: 1px solid #dcdfe6;
        border-radius: 2px;
        background: #fff;
        display: inline-flex;
        align-items: center;
        justify-content: center;

        &.checked {
            background: #409eff;
            border-color: #409eff;

            i {
                color: #fff;
                font-size: 12px;
                font-weight: 700;
            }
        }
    }

    .card-top {
        display: flex;
        align-items: flex-start;
        justify-content: space-between;
        margin-bottom: 12px;
        gap: 8px;

        .card-title-wrap {
            display: flex;
            align-items: center;
            gap: 8px;

            .card-title {
                font-size: 16px;
                font-weight: 600;
                color: #1f2d3d;
                max-width: 200px;
                overflow: hidden;
                text-overflow: ellipsis;
                white-space: nowrap;
            }
        }

        .card-actions {
            display: flex;
            flex-wrap: wrap;
            justify-content: flex-end;
            row-gap: 2px;

            .danger {
                color: #f56c6c;
            }
        }
    }

    .card-body {
        .info-row {
            display: flex;
            align-items: flex-start;
            margin-bottom: 8px;

            &:last-child {
                margin-bottom: 0;
            }

            .label {
                min-width: 78px;
                font-size: 13px;
                color: #7f8c8d;
                line-height: 20px;
            }

            .value {
                flex: 1;
                font-size: 13px;
                color: #34495e;
                line-height: 20px;
                word-break: break-all;
            }
        }
    }
}

.apply-invoice-layout {
    height: calc(100vh - 260px);
    min-height: 460px;
    display: flex;
    flex-direction: column;
    gap: 10px;
}

.apply-invoice-table-wrap {
    flex: 1;
    min-height: 260px;
}

.apply-invoice-pagination {
    text-align: right;
}

::v-deep .apply-invoice-dialog {
    margin-top: 5vh !important;

    .el-dialog__body {
        padding: 12px 18px 8px;
        overflow: hidden;
    }
}

::v-deep .apply-profile-dialog {
    margin-top: 6vh !important;

    .el-dialog__body {
        padding-top: 12px;
    }
}

@media (max-width: 1400px) {
    .invoice-profile-card-list {
        grid-template-columns: 1fr;
    }
}
</style>
